import _ from 'lodash';
import TypesUtil from './utils/types';
import typesData from './utils/typesData';
import platformUtils from 'platformUtils';


const types = new TypesUtil(typesData);

function getDecodedInstance (queryParameters) {
    const instanceStr = platformUtils.getQueryParameter("instance", queryParameters);
    const encodedInstance = instanceStr.substring(instanceStr.indexOf(".") + 1);
    return JSON.parse(atob(encodedInstance));
}

function getInstanceValue (key, queryParameters) {
    const decodedInstance = getDecodedInstance(queryParameters);
    if (decodedInstance) {
        return decodedInstance[key] || null;
    }
    return null;
}

function shallowCloneObject (obj, ignoreKeys) {
    const newObj = {};
    for (const p in obj){
        if(obj.hasOwnProperty(p) && ignoreKeys.indexOf(p) === -1){
            newObj[p] = obj[p];
        }
    }
    return newObj;
}

function allPropertiesFor(obj) {
    const propNames = {};
    let objProto = obj;
    while(objProto !== Object.prototype){
        Object.getOwnPropertyNames(objProto).forEach((prop) => {propNames[prop] = true;});
        objProto = Object.getPrototypeOf(objProto);
    }
    delete propNames.constructor;
    return Object.keys(propNames);
}

function emptyStringIfNil(value) {
    if (typeof value === 'undefined' || value === null) {
        return '';
    }
    return value;
}

function nullIfNil(value) {
    if (typeof value === 'undefined' || value === null) {
        return null;
    }
    return value;
}


function getIndexOrUndefined(collection, key, value) {
    const index = _.findIndex(collection, {[key]: value});
    return index !== -1 ? index : undefined;
}

function isWorker() {
    return typeof Window === 'undefined';
}

function isNilOrEmptyString(value) {
    return _.isNil(value) || value === '';
}

function capitalize(str){
    if(!_.isString(str)){
        return '';
    }
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

function setType (viewerType, sdkType) {
    types.setType(viewerType, sdkType);
}

function reportWixCodeInteraction ({controllerId, appDefinitionId}) {
    const biReporter = platformUtils.getBIReporter();
    if (biReporter) {
        biReporter.reportWixCodeInteraction({controllerId, appDefinitionId});
    }
}


export {
    getInstanceValue,
    shallowCloneObject,
    allPropertiesFor,
    emptyStringIfNil,
    nullIfNil,
    getIndexOrUndefined,
    isWorker,
    isNilOrEmptyString,
    capitalize,
    types,
    setType,
    reportWixCodeInteraction
};



// WEBPACK FOOTER //
// ./js/modules/privates/utils.es6